// Load Styles
import '../../../scss/page/roojai/our-team.scss';
import {utility, toggleScrollToSection} from '../../utility.js';

// Your app code
const professionals_image_swiper = new Swiper( '#professionals-image-swiper', {
  slidesPerView: 1,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  noSwiping: true,
  noSwipingClass: 'swiper-slide',
} );

const professionals_text_swiper = new Swiper( '#professionals-text-swiper', {
  slidesPerView: 1,
  pagination: {
    el: "#professionals-image-swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: "#professionals-image-swiper-wiper-button-next",
    prevEl: "#professionals-image-swiper-wiper-button-prev",
  },
} );

professionals_text_swiper.on( 'slideNextTransitionStart', function() {
  professionals_image_swiper.slideNext();
} );

professionals_text_swiper.on( 'slidePrevTransitionStart', function() {
  professionals_image_swiper.slidePrev();
} );

const indonesian_team_swiper = new Swiper( '#indonesian-team-swiper', {
  slidesPerView: "auto",
  spaceBetween: 16,
  freeMode: {
    enabled: true,
    momentum: false,
  },
  loop: true,
  autoplay: {
    delay: 1,
  },

  speed: 4000,
} );

utility();